module.exports = __webpack_public_path__ + "img/task_status_done.99c7ad40.svg";